// Function to create a persona configuration manager with methods to handle configuration settings.
export const createPersonaConfigManager = (initialConfig) => {
    let config = initialConfig || {};
    return {
        // Determines if a specific configuration option is enabled by checking its boolean value.
        isEnabled: (option) => {
            return !!config[option];
        },
        // Retrieves all enabled configuration options by filtering those with a true value.
        getEnabledOptions: () => {
            return Object.entries(config)
                .filter(([_, value]) => value === true)
                .map(([key]) => key);
        },
        // Updates the current configuration with new or modified settings.
        updateConfig: (newConfig) => {
            Object.assign(config, newConfig);
        },
        // Returns a copy of the current configuration.
        getFullConfig: () => {
            return Object.assign({}, config);
        }
    };
};
//# sourceMappingURL=personaConfigManager.js.map